import React from "react";

const STATE_META = {
  draft:               { label: "Draft",            cls: "bg-slate-500/15 text-slate-400 border-slate-500/30" },
  plan_requested:      { label: "Plan requested",   cls: "bg-cyan-500/15 text-cyan-500 border-cyan-500/30" },
  plan_ready:          { label: "Awaiting approval",cls: "bg-amber-500/15 text-amber-500 border-amber-500/30" },
  approved:            { label: "Approved",         cls: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30" },
  building:            { label: "Building",         cls: "bg-sky-500/15 text-sky-500 border-sky-500/30" },
  emergent_testing:    { label: "Emergent testing", cls: "bg-indigo-500/15 text-indigo-500 border-indigo-500/30" },
  acceptance_testing:  { label: "Acceptance",       cls: "bg-indigo-500/15 text-indigo-500 border-indigo-500/30" },
  fix_requested:       { label: "Fix requested",    cls: "bg-rose-500/15 text-rose-500 border-rose-500/30" },
  changes_requested:   { label: "Changes requested",cls: "bg-amber-600/15 text-amber-600 border-amber-600/30" },
  rejected:            { label: "Rejected",         cls: "bg-rose-500/15 text-rose-500 border-rose-500/30" },
  on_hold:             { label: "On hold",          cls: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30" },
  done:                { label: "Done",             cls: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30" },
};

export const STATE_ORDER = Object.keys(STATE_META);

export function StateBadge({ state, className = "" }) {
  const m = STATE_META[state] || { label: state, cls: "bg-muted text-muted-foreground border-border" };
  return (
    <span
      data-testid={`state-badge-${state}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-mono uppercase tracking-wider ${m.cls} ${className}`}
    >
      {m.label}
    </span>
  );
}

const PRIO_META = {
  low:    "bg-slate-500/10 text-slate-400 border-slate-500/20",
  normal: "bg-sky-500/10 text-sky-500 border-sky-500/20",
  high:   "bg-amber-500/10 text-amber-500 border-amber-500/20",
  urgent: "bg-rose-500/10 text-rose-500 border-rose-500/20",
};

export function PriorityBadge({ priority }) {
  const cls = PRIO_META[priority] || PRIO_META.normal;
  return (
    <span
      data-testid={`priority-${priority}`}
      className={`inline-flex items-center rounded-md border px-1.5 py-0.5 text-[10px] font-mono uppercase tracking-wider ${cls}`}
    >
      {priority}
    </span>
  );
}

export function stateLabel(state) {
  return STATE_META[state]?.label || state;
}
